import React from 'react';
import PropTypes from 'prop-types';

const PUSH_HEADLINE_MAX = 40;
const PUSH_BODY_MAX = 120;

const PushNotificationSection = ({ pushHeadline, onPushHeadlineChange, pushBody, onPushBodyChange }) => (
  <section className='announcements-section'>
    <h2 className='announcements-section-title'>Push Notification</h2>
    <div className='announcements-field'>
      <label className='announcements-label'>
        Push Notification Headline <span className='announcements-label-required'>*</span>
      </label>
      <input
        type='text'
        className='announcements-input'
        value={pushHeadline}
        onChange={e => onPushHeadlineChange(e.target.value.slice(0, PUSH_HEADLINE_MAX))}
        placeholder='Enter push notification headline'
        maxLength={PUSH_HEADLINE_MAX}
      />
      <div className='announcements-char-count'>
        {pushHeadline.length}/{PUSH_HEADLINE_MAX}
      </div>
    </div>
    <div className='announcements-field'>
      <label className='announcements-label'>
        Push Notification Body <span className='announcements-label-required'>*</span>
      </label>
      <input
        type='text'
        className='announcements-input'
        value={pushBody}
        onChange={e => onPushBodyChange(e.target.value.slice(0, PUSH_BODY_MAX))}
        placeholder='Enter push notification body'
        maxLength={PUSH_BODY_MAX}
      />
      <div className='announcements-char-count'>
        {pushBody.length}/{PUSH_BODY_MAX}
      </div>
    </div>
  </section>
);

PushNotificationSection.propTypes = {
  pushHeadline: PropTypes.string.isRequired,
  onPushHeadlineChange: PropTypes.func.isRequired,
  pushBody: PropTypes.string.isRequired,
  onPushBodyChange: PropTypes.func.isRequired
};

export default PushNotificationSection;
